import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, Fragment } from 'react';
import { usePermissionGranted } from '../hooks/usePermissionGranted';
var ProtectedElement = function (_a) {
    var permissions = _a.permissions, children = _a.children, _b = _a.action, action = _b === void 0 ? 'disable' : _b;
    var hasPermission = usePermissionGranted({ permissions: permissions });
    return (_jsx(Fragment, { children: hasPermission ? (children) : action === 'disable' ? (cloneElement(children, { disabled: true })) : (_jsx(Fragment, {})) }));
};
export default ProtectedElement;
